export default __webpack_public_path__ + "static/media/logo-transparent.417c4904.png";